import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["aria-describedby", "aria-invalid", "disabled"]
const _hoisted_3 = ["aria-describedby", "aria-invalid", "disabled"]
const _hoisted_4 = ["aria-describedby", "aria-invalid", "disabled"]
const _hoisted_5 = ["disabled", "aria-busy"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('modal-backdrop') + ' ' + _ctx.getClass('modal-backdrop--custom'))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('modal') + ' ' + _ctx.getClass('transcript-modal')),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Send Transcript modal",
      "aria-describedby": "transcriptModalDescription",
      ref: "transcript_modal"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClass('modal-header'))
      }, [
        _cache[9] || (_cache[9] = _createElementVNode("span", { "aria-hidden": "true" }, " ", -1 /* HOISTED */)),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(_ctx.getClass('btn-close')),
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
          title: "Close",
          disabled: _ctx.transcriptForm.isLoading,
          ref: "closeButton"
        }, _cache[8] || (_cache[8] = [
          _createElementVNode("span", { "aria-hidden": "true" }, "×", -1 /* HOISTED */)
        ]), 10 /* CLASS, PROPS */, _hoisted_1)
      ], 2 /* CLASS */),
      _createElementVNode("section", {
        class: _normalizeClass(_ctx.getClass('modal-body') + ' ' + _ctx.getClass('transcript-modal-body')),
        id: "transcriptModalDescription"
      }, [
        _createElementVNode("form", {
          onSubmit: _cache[7] || (_cache[7] = _withModifiers((...args) => (_ctx.submitTranscript && _ctx.submitTranscript(...args)), ["prevent"])),
          class: _normalizeClass(_ctx.getClass('form-inline'))
        }, [
          _createElementVNode("div", {
            id: "TranscriptForm",
            class: _normalizeClass(_ctx.getClass('transcript-form'))
          }, [
            _createCommentVNode(" Row 1 "),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.getClass('small-text ')),
                ref: "formHeadingLine1"
              }, "Send a copy of the conversation transcript", 2 /* CLASS */),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.getClass('small-text ')),
                ref: "formHeadingLine2"
              }, "to the specified email address.", 2 /* CLASS */)
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('pb-8 '))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-element'))
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.getClass('small-text ') + _ctx.getClass('email-requirement ')),
                  id: "emailRequirement"
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getClass('required-mark')),
                    "aria-hidden": "true"
                  }, "*", 2 /* CLASS */),
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getClass('rule-text')),
                    ref: "emailRequirement"
                  }, "One field is required: either your email or share with.", 2 /* CLASS */)
                ], 2 /* CLASS */)
              ], 2 /* CLASS */)
            ], 2 /* CLASS */),
            _createCommentVNode(" Row 1: Your Email (Required) "),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClass('form-row'))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-element '))
              }, [
                _createElementVNode("label", {
                  for: "userEmail",
                  class: _normalizeClass(_ctx.getClass('form-label'))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getClass('label-text')),
                    ref: "userEmailLabel"
                  }, "Your Email", 2 /* CLASS */),
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getClass('required-mark')),
                    "aria-hidden": "true"
                  }, "*", 2 /* CLASS */)
                ], 2 /* CLASS */),
                _withDirectives(_createElementVNode("input", {
                  maxlength: "500",
                  id: "userEmail",
                  name: "userEmail",
                  class: _normalizeClass([
                  _ctx.getClass('form-input'),
                  _ctx.transcriptForm.errors && _ctx.transcriptForm.errors.email ? _ctx.getClass('is-invalid') : ''
                ]),
                  placeholder: "Your Email",
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.transcriptForm.email) = $event)),
                  tabindex: "0",
                  autocomplete: "email",
                  ref: "userEmail",
                  "aria-required": "true",
                  "aria-describedby": _ctx.emailAriaDescribedBy,
                  "aria-invalid": !!_ctx.transcriptForm.errors.email,
                  onInput: _cache[2] || (_cache[2] = (...args) => (_ctx.onUserInput && _ctx.onUserInput(...args))),
                  disabled: _ctx.transcriptForm.isLoading
                }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2), [
                  [
                    _vModelText,
                    _ctx.transcriptForm.email,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_ctx.transcriptForm.errors.email)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: "userEmailError",
                      class: _normalizeClass(_ctx.getClass('error-message')),
                      role: "alert",
                      "aria-live": "assertive",
                      "aria-atomic": "true"
                    }, _toDisplayString(_ctx.transcriptForm.errors.email), 3 /* TEXT, CLASS */))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */)
            ], 2 /* CLASS */),
            _createCommentVNode(" Row 2: Share With (Optional) "),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClass('form-row'))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-element '))
              }, [
                _createElementVNode("label", {
                  for: "shareWith",
                  class: _normalizeClass(_ctx.getClass('form-label'))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getClass('label-text')),
                    ref: "shareWithLabel"
                  }, "Share With", 2 /* CLASS */),
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getClass('required-mark')),
                    "aria-hidden": "true"
                  }, "*", 2 /* CLASS */)
                ], 2 /* CLASS */),
                _withDirectives(_createElementVNode("textarea", {
                  id: "shareWith",
                  ref: "shareWith",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.transcriptForm.shareWith) = $event)),
                  class: _normalizeClass([
                  _ctx.getClass('form-input'),
                  _ctx.transcriptForm.errors && _ctx.transcriptForm.errors.shareWith ? _ctx.getClass('is-invalid') : ''
                ]),
                  placeholder: "Share With",
                  rows: "2",
                  maxlength: "2000",
                  autocomplete: "off",
                  "aria-required": "true",
                  "aria-describedby": _ctx.shareWithAriaDescribedBy,
                  "aria-invalid": !!_ctx.transcriptForm.errors.shareWith,
                  onInput: _cache[4] || (_cache[4] = (...args) => (_ctx.onUserInput && _ctx.onUserInput(...args))),
                  disabled: _ctx.transcriptForm.isLoading
                }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_3), [
                  [
                    _vModelText,
                    _ctx.transcriptForm.shareWith,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createElementVNode("p", {
                  id: "shareWithHelpText",
                  class: _normalizeClass(_ctx.getClass('small-text ') + _ctx.getClass('text-muted ') + _ctx.getClass('lh-1 ')),
                  ref: "shareWithHelpText"
                }, " Separate with commas for multiple emails ", 2 /* CLASS */),
                (_ctx.transcriptForm.errors.shareWith)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: "shareWithError",
                      class: _normalizeClass(_ctx.getClass('error-message ')),
                      role: "alert",
                      "aria-live": "assertive",
                      "aria-atomic": "true"
                    }, _toDisplayString(_ctx.transcriptForm.errors.shareWith), 3 /* TEXT, CLASS */))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */)
            ], 2 /* CLASS */),
            _createCommentVNode(" Row 3: Note (Optional) "),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClass('form-row'))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-element '))
              }, [
                _createElementVNode("label", {
                  for: "note",
                  class: _normalizeClass(_ctx.getClass('form-label'))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getClass('label-text')),
                    ref: "noteLabel"
                  }, "Add a note (optional)", 2 /* CLASS */)
                ], 2 /* CLASS */),
                _withDirectives(_createElementVNode("textarea", {
                  id: "note",
                  ref: "note",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.transcriptForm.note) = $event)),
                  class: _normalizeClass([
                  _ctx.getClass('form-input'),
                  _ctx.transcriptForm.errors && _ctx.transcriptForm.errors.note ? _ctx.getClass('is-invalid') : ''
                ]),
                  placeholder: "Add a note (optional)",
                  rows: "4",
                  maxlength: "5000",
                  autocomplete: "off",
                  "aria-describedby": _ctx.noteAriaDescribedBy,
                  "aria-invalid": !!_ctx.transcriptForm.errors.note,
                  onInput: _cache[6] || (_cache[6] = (...args) => (_ctx.onUserInput && _ctx.onUserInput(...args))),
                  disabled: _ctx.transcriptForm.isLoading
                }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_4), [
                  [
                    _vModelText,
                    _ctx.transcriptForm.note,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createElementVNode("p", {
                  id: "noteHelpText",
                  class: _normalizeClass(_ctx.getClass('small-text ') + _ctx.getClass('text-muted ') + _ctx.getClass('lh-1 ')),
                  ref: "noteHelpText"
                }, " This note will be included with the transcript email ", 2 /* CLASS */),
                (_ctx.transcriptForm.errors.note)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: "noteError",
                      class: _normalizeClass(_ctx.getClass('error-message ')),
                      role: "alert",
                      "aria-live": "assertive",
                      "aria-atomic": "true"
                    }, _toDisplayString(_ctx.transcriptForm.errors.note), 3 /* TEXT, CLASS */))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */)
            ], 2 /* CLASS */),
            _createCommentVNode(" General Error Message "),
            (_ctx.transcriptForm.errors.general)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_ctx.getClass('form-row'))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getClass('gen-error-message')),
                    role: "alert",
                    "aria-live": "assertive",
                    "aria-atomic": "true"
                  }, _toDisplayString(_ctx.transcriptForm.errors.general), 3 /* TEXT, CLASS */)
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Success Message "),
            (_ctx.messageState.successMessage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(_ctx.getClass('form-row'))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getClass('gen-success-message')),
                    role: "alert",
                    "aria-live": "assertive",
                    "aria-atomic": "true"
                  }, _toDisplayString(_ctx.messageState.successMessage), 3 /* TEXT, CLASS */)
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Form Actions "),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('pb-0 '))
            }, [
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(_ctx.getClass('btn-transcript ') + _ctx.getClass('btn-block ')),
                disabled: _ctx.isButtonDisabled,
                "aria-busy": _ctx.transcriptForm.isLoading
              }, [
                (_ctx.transcriptForm.isLoading)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(_ctx.getClass('loading-spinner')),
                      "aria-hidden": "true"
                    }, null, 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                _createTextVNode(" " + _toDisplayString(_ctx.buttonText), 1 /* TEXT */)
              ], 10 /* CLASS, PROPS */, _hoisted_5)
            ], 2 /* CLASS */)
          ], 2 /* CLASS */)
        ], 34 /* CLASS, NEED_HYDRATION */)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}